export default __webpack_public_path__ + "static/media/desc.5a330484.svg";